import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import Photos from './components/Photos'
import 'url-search-params-polyfill';
import { getAllRounds, getGlobalScriptsForCustomer } from "../actions/PhotowallActions";
import { loadLocale } from "../actions/LocaleAction";
import FadeLoader from "react-spinners/FadeLoader";
import $ from 'jquery';
import ReactDOM from 'react-dom'

import {trackOptin, trackSession, trackVote} from "../actions/TrackingActions";
import {
    initReactI18next,
    withTranslation,
} from "react-i18next";
import i18n from "i18next";
import { getGlobalCode, getUrlWord, injectGlobalCode } from '../util/helpers/Helpers';

class App extends Component {

    constructor(props) {

        super(props);

        this.state = {
            tncs: false,
            optin: false,
            codeInjected: false,
            loader: false,
            anchor: null
        }
        this.showLoader = this.showLoader.bind(this);

    }

    resizeContainer = () => {
        const { competition: comp } = this.props;
        const { data } = comp;

        let useStyle = false;
        let useStyleBg = '';

        if (data) {
            if(data.bgColor){
                document.getElementById('root').style.backgroundColor  = data.bgColor;
                document.getElementById('root').style.minHeight = '100vh';
            }
            const iw = window.innerWidth;

            if (data.desktopBg) {
                useStyle = true;
                useStyleBg = data.desktopBg.file;
            }

            // if (data.desktopBg && iw >= 1024) {
            //     // document.body.style.backgroundImage = `url(${data.desktopBg.file})`;
            //     useStyle = true;
            //     useStyleBg = data.desktopBg.file;
            // }
            if (data.tabletBg && iw < 1024 && iw >= 450) {
                // document.body.style.backgroundImage = `url(${data.tabletBg.file})`;
                useStyle = true;
                useStyleBg = data.tabletBg.file;
            } else if (data.mobileBg && iw < 450) {
                // document.body.style.backgroundImage = `url(${data.mobileBg.file})`;
                useStyle = true;
                useStyleBg = data.mobileBg.file;
            }

            // iphone/ipad background fix
            if (useStyle) {
                const styles = `
                    body {
                    background: url(${useStyleBg}) no-repeat center center fixed;
                    }

                    body:after{
                        content:"";
                        position:fixed; /* stretch a fixed position to the whole screen */
                        top:0;
                        height:100vh; /* fix for mobile browser address bar appearing disappearing */
                        left:0;
                        right:0;
                        z-index:-1; /* needed to keep in the background */
                        background: url(${useStyleBg}) center center;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                    }
                `;

                var styleSheet = document.createElement("style");
                styleSheet.innerText = styles;
                document.head.appendChild(styleSheet);
            }

            document.title = data.name.replace(/(<([^>]+)>)/ig, ' ').trim();
            window.setTimeout(() => {
                let elHeight = document.body.scrollHeight;
                if (window.self !== window.top) {
                    window.parent.postMessage(
                        `benchvoteResize-${elHeight}`
                    );
                }
            }, 500);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('prev-props', prevProps);
        if (!prevProps.competition.dataAvailable && this.props.competition.dataAvailable && !window.codeInjectedForEntryPage) {
            this.resizeContainer();
            // this.props.dispatch(trackSession(this.props.competition.data.id, this.props.dispatch));
            const codeSamples = this.props.competition.data.codeSnippetsForInjection || [];
            for(let i = 0; i < codeSamples.length; i++) {
                if(codeSamples[i].page === 'global' && codeSamples[i].htmlTagName && codeSamples[i].codeToBeInjected) {
                    $(codeSamples[i].htmlTagName).append(codeSamples[i].codeToBeInjected);
                } else if(codeSamples[i].page === 'entry' && codeSamples[i].codeToBeInjected) {
                    $(ReactDOM.findDOMNode(this)).append(codeSamples[i].codeToBeInjected);
                }
            }
            window.codeInjectedForEntryPage = true;
            this.props.dispatch(trackSession(this.props.competition.data.id, this.props.dispatch));

            // CSS FILES
            var fileref = document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.cssContentUrl)
            if (typeof fileref != "undefined") {
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }

            // FONT CSS FILES
            var fileref = document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.fontUrl)
            if (typeof fileref != "undefined") {
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }
        }

        //to load language
        if (!prevProps.competition.data && this.props.competition.data) {

            this.props.dispatch(
                loadLocale(this.props.competition.data.localeId, this.props.dispatch)
            );
            this.props.dispatch(
                loadLocale(this.props.competition.data.localeId, this.props.dispatch)
            );
        }
        if (
            this.props.locale.lang &&
            Object.keys(this.props.locale.lang).length !== 0 &&
            !prevProps.locale.lang.pick_now
        ) {
            setTimeout(() => {
                this.setState({ ...this.state, loader: false })
            }, 500)

            i18n.use(initReactI18next).init({
                lang: this.props.competition.data.localeId,
                fallbackLng: this.props.competition.data.localeId,
                debug: true,
                ns: ["common"],
                defaultNS: "common",
                interpolation: {
                    escapeValue: false // not needed for react as it escapes by default
                },
                resources: {
                    [this.props.competition.data.localeId]: {
                        common: this.props.locale.lang
                    }
                }
            });
        }

        if (this.props.competition && this.props.competition.submitted
            && this.props.competition.submittedIdImage && !prevProps.competition.submittedIdImage
            && this.props.tracking && this.props.tracking.flakeId) {
            const idUser = this.props.competition.submittedIdImage;
            const { flakeId } = this.props.tracking;
            console.log("Submitting optin vote tracking");
            this.props.dispatch(
                trackOptin(
                this.props.competition.data.id,
                idUser,
                flakeId,
                this.props.dispatch
                )
            );
            this.props.dispatch(
                trackVote(
                this.props.competition.data.id,
                idUser,
                flakeId,
                this.props.dispatch
                )
            );
        }

        if (!prevProps.globalScript.globalScriptFetched && this.props.globalScript.globalScriptFetched) {
            console.log('propps-ok-new', this.props.globalScript.globalScriptData);
            let gsd = this.props.globalScript.globalScriptData;
            if (gsd && gsd != {}) {
                if (gsd.globalCodeForHeader && gsd.globalCodeForHeader != {}) {
                injectGlobalCode($, 'head', getGlobalCode(gsd.globalCodeForHeader));
                }
                if (gsd.globalCodeForBody && gsd.globalCodeForBody != {}) {
                injectGlobalCode($, 'body', getGlobalCode(gsd.globalCodeForBody));
                }
                if (gsd.globalCodeForFooter && gsd.globalCodeForFooter != {}) {
                injectGlobalCode($, 'footer', getGlobalCode(gsd.globalCodeForFooter));
                }
            }
        }
    }

    componentDidMount() {

        // let hash = this.props.location.hash;
        // hash = hash ? hash.replace(/(^#)/g, "") : '';

        let hash = getUrlWord(this.props.match.url, this.props.location.hash);

        if (hash) {
            this.props.dispatch(getGlobalScriptsForCustomer(hash, this.props.dispatch));
            this.props.dispatch(getAllRounds(
                hash,
                this.props.dispatch
            ));
            this.setState({ hash });
            this.setState({ ...this.state, loader: true })
        }

    }

    showLoader(app, e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        if (e) {
            window.scrollTo(0, 0);
        }

        this.setState({
            loader: e
        })
    }

    getUrlExtension = (url) => {
      return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    getVideoExtensions = (url) => {
      return ['mp4', 'avi', 'webm', 'mov']
    }

    isVideo = (url) => {
      var urlExt = this.getUrlExtension(url);
      return (this.getVideoExtensions().includes(urlExt));
    }

    render() {

        let noBorderRadius = (this.props && this.props.competition
            && this.props.competition.data && this.props.competition.data.defaultShape == 2);

        console.log('app-props', this.props);
        return (
            <React.Fragment>

                {this.props && this.props.competition && this.props.competition.data
                  && this.props.competition.data.desktopBg && this.props.competition.data.desktopBg.file
                  && this.isVideo(this.props.competition.data.desktopBg.file)
                ? <video autoPlay={true} muted={true} loop={true} playsInline={true} id="myVideo">
                      <source src={this.props.competition.data.desktopBg.file} type="video/mp4"/>
                </video> : null}

                {this.state.loader ?
                <div className={"loaderCss"}>
                    <style dangerouslySetInnerHTML={{
                        __html: `
                    body { overflow: hidden; }
                    `}} />
                    <div className={"loader"} ><FadeLoader size={150} color={"#ffffff"} loading={this.state.loader} /></div>
                </div> : null}
                <div className={'content ' + (noBorderRadius ? 'no-border-radius' : '')}>

                  {/* <video ng-if="desktopBg.file && isVideo(desktopBg.file)" autoplay muted loop id="myVideo">
                      <source src="{{desktopBg.file}}" type="video/mp4">
                      <!-- <source type="video/mp4" src="https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/sandbox/others/video_background_cronullasharks.mp4"> -->
                  </video> */}
                    <div className='panels-cont'>
                        <div className='left-panel'>
                            <Photos showLoader={(e) => this.showLoader(this, e)} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const prj = state.default;
    return {
        ...ownProps,
        competition: prj.competition,
        comp: prj.competition.data,
        auth: prj.auth,
        tracking: prj.tracking,
        locale: prj.locale,
        globalScript: prj.competition.globalScript
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
